import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const dailyMissionSettingReducer = createReducer(initialState)({
    [types.AGENT_PROMOTE_LINK_LIST]: (state, action) => ({
        ...state,
        agent_promote_link_list: action.payload
    }),

    [types.AGENT_PROMOTE_LINK_CREATE]: (state, action) => ({
        ...state,
        agent_promote_link_create: action.payload
    }),

    [types.AGENT_PROMOTE_LINK_SHOW]: (state, action) => ({
        ...state,
        agent_promote_link_show: action.payload
    }),

    [types.AGENT_PROMOTE_LINK_STATUS]: (state, action) => ({
        ...state,
        agent_promote_link_status: action.payload
    })
});

export default dailyMissionSettingReducer;